import type { CheckoutProductPayload } from "@/app/core/TokensPayment/checkOutComp/subscribe/shared/catalogTypes";

export interface CheckoutLocationState extends CheckoutProductPayload {
  promoCode?: string;
}

export function isCheckoutLocationState(value: unknown): value is CheckoutLocationState {
  if (!value || typeof value !== "object") return false;
  const payload = value as Record<string, unknown>;
  return (
    (payload.productType === "subscription" || payload.productType === "tokens") &&
    typeof payload.productCode === "string" &&
    typeof payload.productId === "string" &&
    typeof payload.productName === "string" &&
    typeof payload.priceRub === "number"
  );
}
